import { defineStore } from "pinia";
import { useSessionStore } from "@/stores/sessionStore";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
const apiGatewayRepository = RepositoryFactory.get('apiGateway');
import ApplicationError from "@/helpers/applicationError";
import { API_RESPONSE_SUCCESS } from "@/data/constants";
import i18n from '@/i18n/main'

const { t } = i18n.global;
export const useCompanyAppStore = defineStore('companyApp', {
    state: () => ({
        isLoading: false,
        siteName: '',
        status: null,
        page: 1,
        totalPages: null,
        registeredApps: []
    }),
    getters: {
        getUserInfo(state) {
            return useSessionStore().session_data;
        },
    },
    actions: {
        async getRegisteredMerchants(page){
            this.isLoading = true;
            try {
                let sessionData = this.getSessionIdAndAuthId();
                apiGatewayRepository.ssid = sessionData.HVCHUBSYNCHSSID;
                apiGatewayRepository.auth_id = sessionData.auth_id;

                const toppageData = await apiGatewayRepository.getTopPageData({
                    site_name: this.siteName,
                    status: this.status,
                    limit: parseInt(process.env.VUE_APP_PAGINATION_LIMIT),
                    offset: page != null ? (page-1) * process.env.VUE_APP_PAGINATION_LIMIT : 0,
                });

                if (toppageData.success == API_RESPONSE_SUCCESS) {
                    this.registeredApps = toppageData.data == null ? [] : toppageData.data;
                    this.totalPages = toppageData.meta.total != null && toppageData.meta.limit != null ? Math.ceil(toppageData.meta.total / toppageData.meta.limit) : 1;
                }
            } catch (e) {
                this.isLoading = false;
                throw new ApplicationError(e.message, {}, e)
            }
            this.isLoading = false;
        },
        async getActiveRegisteredMerchants(){
            this.isLoading = true;
            try {
                let sessionData = this.getSessionIdAndAuthId();
                apiGatewayRepository.ssid = sessionData.HVCHUBSYNCHSSID;
                apiGatewayRepository.auth_id = sessionData.auth_id;

                const toppageData = await apiGatewayRepository.getTopPageData({
                    status: 'active',
                    limit: 100,
                    offset: 0,
                });
                if (toppageData.success == API_RESPONSE_SUCCESS) {
                    this.registeredApps = toppageData.data == null ? [] : toppageData.data;
                    this.totalPages = toppageData.meta.total != null && toppageData.meta.limit != null ? Math.ceil(toppageData.meta.total / toppageData.meta.limit) : 1;
                }
            } catch (e) {
                this.isLoading = false;
                throw new ApplicationError(e.message, {}, e)
            }
            this.isLoading = false;
        },
        async resign(companyAppId) {
            try {
                const userInfo = this.getUserInfo;

                const params = {
                    user_id: Number(userInfo.hubsynch_id).toString(),
                    resign_app_id: companyAppId,
                    resign_from_all_apps: "false"
                };

                await apiGatewayRepository.resign(params);

            } catch (e) {
                throw new ApplicationError(e.message, {}, e)
            }
        },
        getSessionIdAndAuthId() {
            return {
                'HVCHUBSYNCHSSID': localStorage.getItem('HVCHUBSYNCHSSID'),
                'auth_id': localStorage.getItem('auth_id'),
                'hubsynch_id': localStorage.getItem('hubsynch_id')
            }
        },
    }
});